export default "__VITE_ASSET__CQ2hC2bL__"